import { useEffect, useState } from 'react';
import { situacaoInatividade } from '../domain/inatividade';
import type { GerenciadorSessao } from './sessao';

const MOVIMENTOS = ['pointermove', 'pointerdown', 'keydown', 'wheel', 'scroll', 'touchstart'] as const;

/**
 * Logout por inatividade (RQ-ACE-014): escuta movimento, teclado, toque e rolagem, compartilha o último movimento
 * entre as abas pela sessão e, passado o limite, devolve os segundos do aviso; ao fim do aviso, chama `aoSair`.
 * Aba suspensa ou congelada confere de novo ao voltar e sai na hora se o prazo já passou.
 */
export function useInatividade(sessao: Pick<GerenciadorSessao, 'ultimaAtividade' | 'registrarAtividade'>, limiteMinutos: number, aoSair: () => void) {
  const [restanteMs, definirRestante] = useState<number | null>(null);

  useEffect(() => {
    const mover = () => sessao.registrarAtividade();
    for (const evento of MOVIMENTOS) window.addEventListener(evento, mover, { capture: true, passive: true });
    let saiu = false;
    const conferir = () => {
      const situacao = situacaoInatividade(sessao.ultimaAtividade, Date.now(), limiteMinutos);
      if (situacao.fase === 'sair' && !saiu) {
        saiu = true;
        aoSair();
      }
      definirRestante(situacao.fase === 'aviso' ? Math.ceil(situacao.restanteMs / 1000) * 1000 : null);
    };
    const relogio = setInterval(conferir, 1000);
    document.addEventListener('visibilitychange', conferir);
    return () => {
      for (const evento of MOVIMENTOS) window.removeEventListener(evento, mover, { capture: true });
      clearInterval(relogio);
      document.removeEventListener('visibilitychange', conferir);
    };
  }, [sessao, limiteMinutos, aoSair]);

  return { restanteMs, continuar: () => sessao.registrarAtividade() };
}
